import React from 'react';

const TRACK_TYPE_ICONS = {
  circuit: 'circuit.svg',
  oval: 'oval.svg',
  karting: 'karting.svg',
  roval: 'roval.svg',
  street: 'street.svg',
  autocross: 'autocross.svg',
  hillclimb: 'hillclimb.svg',
  dragstrip: 'dragstrip.svg',
  dirt: 'dirt.svg',
};

const DEFAULT_TRACK_TYPE_ICON = 'default.svg';

export function normalizeTrackTypeValue(trackType) {
  return String(trackType || 'unknown')
    .toLowerCase()
    .replace(/[\s_-]+/g, '');
}

export function getTrackTypeIcon(trackType) {
  const normalized = normalizeTrackTypeValue(trackType);
  const fileName = TRACK_TYPE_ICONS[normalized] || DEFAULT_TRACK_TYPE_ICON;
  return `/api/tracks/icons/${fileName}`;
}

export function TrackTypeIcon({ trackType, size = 18, style, alt = '' }) {
  const icon = getTrackTypeIcon(trackType);
  return <img src={icon} alt={alt} width={size} height={size} style={{ flexShrink: 0, ...style }} />;
}
